import InputChangeMonitor from 'core/components/utilities/input_change_monitor';

class StoreSlugFieldManager {
  constructor(
    fieldSelector,
    warningSelector,
  ) {
    this.monitor = new InputChangeMonitor(fieldSelector, warningSelector);
    this.monitor.init();

    this.field = document.querySelector(`.${fieldSelector}`);
    this.form = this.field.form;

    this.dialogWrapper = document.querySelector('.jsDialogComponentWrapper');
    this.dialogSwitches = document.querySelectorAll('.jsDialogSwitch');
  }

  init() {
    this.dialogSwitches.forEach(dialogSwitch => {
      dialogSwitch.addEventListener('click', e => this.handleFormSubmit(e, dialogSwitch));
    });
  }

  handleFormSubmit(e, dialogSwitch) {
    if (this.monitor.showWarningMessage()) {
      e.preventDefault();
      this.dialogWrapper.dialogComponent.triggerDialog(e);
    } else {
      this.form.submit();
    }
  }
}

export default StoreSlugFieldManager;
